module.exports = __webpack_public_path__ + "img/appBarFinish.669c1330.png";